export default "__VITE_ASSET__EW$n_ust__"